export { default as useMaterialsFiltersCache } from './useMaterialsFiltersCache';
